import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, CommonModule],
  template: `
    <router-outlet></router-outlet>
  `,
})
export class AppComponent {
  // Authentication and user loading is now handled by APP_INITIALIZER
  // This ensures the /me endpoint is called before any other services
}
